export default {
  APP: {
    CHANGE_LOCALE: 'APP.CHANGE_LOCALE',
  },
};
